<ng-container *ngIf="nzLoading">
  <div class="ant-skeleton-header" *ngIf="!!nzAvatar">
    <ui-skeleton-element skeletonType="avatar" [uiSize]="avatar.size || 'default'" [uiShape]="avatar.shape || 'circle'"></ui-skeleton-element>
  </div>
  <div class="ant-skeleton-content">
    <h3 *ngIf="!!nzTitle" class="ant-skeleton-title" [style.width]="toCSSUnit(title.width)"></h3>
    <ul *ngIf="!!nzParagraph" class="ant-skeleton-paragraph">
      <li *ngFor="let row of rowsList; let i = index" [style.width]="toCSSUnit(widthList[i])"></li>
    </ul>
  </div>
</ng-container>
<ng-container *ngIf="!nzLoading">
  <ng-content></ng-content>
</ng-container>
